import { useState } from 'react'

import { theme } from '@hhgtech/hhg-components'
import { Text } from '@hhgtech/hhg-components/mantine'
import { Button, List, Stack, StackProps } from '@mantine/core'
import { useIntl } from 'react-intl'

import { assetImagePath } from 'interfaces/constants'
import { useExpertStore } from 'state/expert'

type _CertificateProps = StackProps

export const _Certificate = ({ ...rest }: _CertificateProps) => {
  const { formatMessage: f } = useIntl()
  const [showAllAwards, setShowAllAwards] = useState(true)
  const { currentExpert: expert } = useExpertStore((state) => ({
    currentExpert: state.currentExpert,
  }))

  return (
    <>
      {expert?.fields?.awards_accreditations &&
        Array.isArray(expert?.fields?.awards_accreditations) &&
        expert?.fields?.awards_accreditations.length > 0 && (
          <Stack spacing={16} {...rest}>
            <Text weight="bold" size="c2" color={theme.colors.gray400}>
              {f({
                id: 'expert.content.awards',
                defaultMessage: 'Awards & Accreditations',
              }).toUpperCase()}
            </Text>

            <List
              styles={{
                itemIcon: {
                  marginRight: 0,
                },
              }}
              spacing={12}
              icon={
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="2" fill="#2D87F3" />
                </svg>
              }
            >
              {(showAllAwards
                ? expert?.fields?.awards_accreditations
                : expert?.fields?.awards_accreditations.slice(0, 3)
              ).map((awards_accreditation, index) => (
                <List.Item key={`item-${index}`}>
                  <Stack spacing={0}>
                    <Text size="p3" color={theme.colors.gray800}>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: awards_accreditation.title,
                        }}
                      />
                    </Text>
                  </Stack>
                </List.Item>
              ))}
            </List>
            {expert?.fields?.awards_accreditations.length > 3 &&
              !showAllAwards && (
                <Button
                  variant="ghost"
                  compact
                  size="sm"
                  w="fit-content"
                  rightIcon={
                    <img
                      src={`${assetImagePath}/chevronDownBlue.svg`}
                      alt="see-more"
                      loading="lazy"
                    />
                  }
                  onClick={() => setShowAllAwards(true)}
                >
                  {f({
                    id: 'expert.content.seeMore',
                    defaultMessage: 'See more',
                  })}
                </Button>
              )}
          </Stack>
        )}
    </>
  )
}
